import Layout from '@layouts/Desktop';
import { useAppSelector } from '@store/hooks';
import { FC, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import Loading from '../../../Loading';

import { Props } from './types';

const SafeRoute: FC<Props> = ({ children, isProtected }) => {
  const { isAuthenticated, sessionLoading, authChecked } = useAppSelector(
    (state) => state.auth,
  );

  if (!authChecked || sessionLoading) {
    return <Loading size={50} containerMode />;
  }

  const content = (
    <Layout>
      <Suspense fallback={<Loading size={50} containerMode />}>
        {children}
      </Suspense>
    </Layout>
  );

  return isProtected ? (
    isAuthenticated ? (
      content
    ) : (
      <Navigate to="/login" replace />
    )
  ) : (
    content
  );
};

export default SafeRoute;
